import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderDetailLink = ({
    schemaItem,
    item,
    columnKey,
}: TableCellProps) => (
    <td class={schemaItem.className} data-testid={columnKey}>
        <ux-button
            icon="chevron-right"
            size="icon"
            href={item[columnKey]}
        ></ux-button>
    </td>
);
